import { combineReducers } from 'redux'
import { reducers as I18nReducers } from './I18n'
import { reducers as TrialReducers } from './Trial'


// Functions to catch actions dispatched
export default combineReducers({
    I18nReducers,
    TrialReducers,
});